import { useTranslation } from '@pancakeswap/localization'
import { memo } from 'react'
import { useSwapActionHandlers } from '@/state/swap/useSwapActionHandlers'
import { useSwapState } from '@/state/swap/hooks'
import AddressInputPanel from '../../components/AddressInputPanel'
import { useAllowRecipient } from '../hooks'

export const Recipient = memo(function Recipient() {
  const { t } = useTranslation()
  const { recipient } = useSwapState()
  const { onChangeRecipient } = useSwapActionHandlers()
  const allowRecipient = useAllowRecipient()

  if (!allowRecipient || recipient === null) {
    return null
  }

  return (
    <>
      <div className={'flex justify-end'}>
        <button
          type={'button'}
          onClick={() => onChangeRecipient(null)}
          className={'text-muted-foreground text-sm mt-2 cursor-pointer'}
        >
          {t('- Remove send')}
        </button>
      </div>
      <AddressInputPanel id="recipient" value={recipient} onChange={onChangeRecipient} />
    </>
  )
})
